module.exports = __webpack_public_path__ + "img/xin.cd553933.svg";